import React, { memo } from 'react';

import { useSelector } from 'react-redux';

import _isEqual from 'lodash/isEqual';

import vdpResultsDuck from '@/ducks/vdp/vdpResultsDuck.js';

import VehicleFeaturesCarousel from './VehicleFeaturesCarousel';

function VehicleFeaturesContainer() {

    const listing = useSelector((state) => vdpResultsDuck.selectors.getVdpActiveInventory(state));
    const { features, packages = [], make = '', model = '', title = '', rankedFeatures } = listing;

    const sectionHeader = `Get to know this ${make?.name ?? make} ${model?.name ?? model}`;

    return (
        <VehicleFeaturesCarousel
            rankedFeatures={rankedFeatures}
            sectionHeader={sectionHeader}
            packages={packages}
            features={features}
            vehicleTitle={title}
        />
    );

}

export default memo(VehicleFeaturesContainer, _isEqual);
